import { IInventoryRepository } from '@/coreInfrastructureModule/interfaces/IInventoryRepository';
import { SortType } from '@/coreInfrastructureModule/axios/generated/inventoryManage';
import { FilterContentItem } from '@/corePagesModule/filterModal/filterModal';
import { FilterService } from '@/coreDomainsModule/services/filterService';
import { IError } from '@/coreInfrastructureModule/interfaces/IError';
import { INetworkResult } from '@/coreDomainsModule/networkResult';
import { GetEditIndividualBusinessAdapter } from '../adapters/getEditIndividualBusinessAdapter';
import { IGetEditBusinessAggregateBusinessResult } from '../domains/entities/getEditBusinessAggregateBusinessResult';

/**
 * 編集ページの集計情報取得UseCase
 */
export class GetEditBusinessAggregateBusinessUseCase {
  private repository: IInventoryRepository;

  /**
   * コンストラクタ
   * @param repository - リポジトリ
   */
  constructor(repository: IInventoryRepository) {
    this.repository = repository;
  }

  /**
   * 集計情報の取得
   * @param sortType - ソートタイプ
   * @param limit - 取得件数
   * @param offset - 取得開始位置
   * @param earlyPeriod - 表示期間の開始日
   * @param latterPeriod - 表示期間の終了日
   * @param sortTarget - ソート対象
   * @param filterItems - フィルターの一覧
   * @returns - 集計情報
   */
  public async execute(
    sortType: SortType,
    limit: number,
    offset: number,
    earlyPeriod: string,
    latterPeriod: string,
    sortTarget: string,
    filterItems: FilterContentItem[]
  ): Promise<INetworkResult<IGetEditBusinessAggregateBusinessResult, IError>> {
    const filterItem = FilterService.convertCustomerForecastFilterItems(filterItems);
    try {
      const response = await this.repository.get(sortType, limit, offset, earlyPeriod, latterPeriod, undefined, sortTarget, filterItem, '');
      if (response.status.type === 'success') {
        return {
          status: {
            type: 'success',
            data: GetEditIndividualBusinessAdapter.adaptAggregateBusiness(response.status.data.result),
          },
        };
      } else {
        return {
          status: {
            type: 'error',
            error: response.status.error,
          },
        };
      }
    } catch (error) {
      console.error('error', error);
      return {
        status: {
          type: 'error',
          error: {
            statusCode: 500,
            code: 'unknown',
            message: '未知のエラーが発生しました',
          },
        },
      };
    }
  }
}
